module.exports = __webpack_public_path__ + "static/media/YF83_1.98413d8d.jpg";